<template>
  <div v-if="isSectionPromoted">
    <div class="badge-container">
      <div class="badge-dot" />
      <span class="badge-header" v-localize="NEW_ARRIVAL_TEXT_KEY" />
      <div class="badge-dot" />
    </div>
  </div>
</template>

<script>
import { LocalizationDirective } from '@/directives/LocalizationDirective';

export default {
  name: 'NewArrivalBadge',
  props: [
    'brandData', //: Object
    'categoryKey', //: String
  ],
  created: function() {
    this.NEW_ARRIVAL_TEXT_KEY = 'NewArrivalHeader';
  },
  computed: {
    isSectionPromoted() {
      return this.$store.getters.isSectionPromoted(this.categoryKey, this.brandData.id);
    },
  },
  directives: {
    LocalizationDirective,
  },
};
</script>

<style scoped>
.badge-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  color: #fff;
  background: #0a92ff;
  margin: auto 5px auto 5px;
}

.badge-header {
  font-family: Avenir Next, sans-serif;
  font-weight: bold;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.16em;
  color: #0a92ff;
}
.badge-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
</style>
